import React, { Component } from "react";
import * as s from "./FAQDropdown.module.scss";
import { Icons } from "src/libs/assets";
import { P } from "src/views/shared/components";

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  question: string;
  answer: string;
}

interface State {
  open: boolean;
}

export class FAQDropdown extends Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  toggleDropdown = () => {
    this.setState({
      open: !this.state.open
    });
  };

  render() {
    const { className, question, answer } = this.props;
    const { open } = this.state;

    const dropdownClasses = [s.faqDropdown];
    const dropdownContentClasses = [s.dropdownContent];
    let icon = Icons.chevronDown_small;

    if (open) {
      dropdownContentClasses.push(s.open);
      icon = Icons.chevronUp_small;
    }

    if (className) {
      dropdownClasses.push(className);
    }

    return (
      <div className={dropdownClasses.join(" ")}>
        <div className={s.dropdownHeader} onClick={this.toggleDropdown}>
          <img src={icon} alt="dropdown-chevron" className={s.dropdownChevronIcon} />
          <P medium className={s.dropdownQuestion}>
            {question}
          </P>
        </div>
        <div className={dropdownContentClasses.join(" ")}>
          <P medium className={s.dropdownAnswer}>
            {answer}
          </P>
        </div>
      </div>
    );
  }
}
